import React from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import { Container } from './styles';

// Components
import { TruncatedText } from '../TruncatedText';
import { Typography } from '../Typography';

// Types
import { ExternalCompaniesCellProps } from './types';

export const ExternalCompaniesCell: React.FC<ExternalCompaniesCellProps> = ({
  companies,
  maxVisible = 2,
  className,
}) => {
  const { t } = useTranslation('budgets');

  // Si no hay empresas, mostrar guión
  if (!companies || companies.length === 0) {
    return (
      <Container className={className}>
        <Typography size="S" colorText="black">
          -
        </Typography>
      </Container>
    );
  }

  // Si hay menos o igual al máximo visible, mostrar todas.
  //
  // El `title` es la red de seguridad: no hay tooltip propio en este caso
  // —no se considera truncado— pero la celda sí puede recortar por CSS si la
  // columna es estrecha, y entonces el texto quedaría inaccesible. Mismo
  // recurso que usa la columna de Operarios.
  if (companies.length <= maxVisible) {
    const allCompanies = companies.join(', ');
    return (
      <Container className={className} title={allCompanies}>
        <Typography size="S" colorText="black">
          {allCompanies}
        </Typography>
      </Container>
    );
  }

  // Si hay más del máximo, usar TruncatedText con tooltip
  const allCompaniesText = companies.join(', ');
  const visibleCompanies = companies.slice(0, maxVisible);
  const truncatedText = `${visibleCompanies.join(', ')}...`;

  return (
    <Container className={className}>
      <TruncatedText
        text={allCompaniesText}
        maxLength={truncatedText.length - 3} // Subtract 3 for the "..."
        size="S"
        colorText="black"
      />
    </Container>
  );
};
